// import axios from "axios";
let model = {};


let isProduction = process.env.NODE_ENV === "production";
// const AjaxBaseURL = "http://apss.qhnu.edu.cn";
const AjaxBaseURL = isProduction ? "http://apss.qhnu.edu.cn":"http://apps.qhnews.com/";
const AjaxDebugChannelID = "5dc6166ce138233f8f9d6971";
model.ApiArtilceURL = "/api/article";

model.http = axios.create({
  baseURL: AjaxBaseURL,
  timeout: 30000
});

model.GetArticlesByChannelID = function() {
  var args = Array.prototype.slice.call(arguments);
  var channelID = args[0] == undefined ? "" : args[0];
  var pageOffset = args[1] == undefined || args[1] == null ? "" : args[1];
  var pageCount = args[2] == undefined ? 8 : args[2];
  return this.http(this.ApiArtilceURL, {
    params: {
      ChannelID: isProduction ? channelID : AjaxDebugChannelID,
      PageOffset: pageOffset,
      PageCount: pageCount,
      ISLess: false
    }
  });
};

model.GetArticlesForPagesByChannelID = function() {
  var args = Array.prototype.slice.call(arguments);
  var channelID = args[0] == undefined ? "" : args[0];
  var pageNum = args[1] == undefined ? 1 : parseInt(args[1]);
  var pageCount = args[2] == undefined ? 36 : parseInt(args[2]);
  return this.http(this.ApiArtilceURL, {
    params: {
      // ChannelID: channelID,
      ChannelID: isProduction ? channelID:AjaxDebugChannelID,
      PageNum: pageNum,
      PageCount: pageCount,
      ISLess: false
    }
  });
};

model.GetChannelIDSingePage = function() {
  var args = Array.prototype.slice.call(arguments);
  var channelID = args[0] == undefined ? "" : args[0];
  var singePage = args[1] == undefined ? false : args[1];
  return this.http(this.ApiArtilceURL, {
    params: {
      ChannelID: channelID,
      SingePage: singePage
    }
  });
};

model.GetArticle = function(id) {
  return this.http(this.ApiArtilceURL, {
    params: {
      ArticleID: id
    }
  });
};

model.GetChannelName = function(id) {
  var result = "";
  for (var i = 0; i < channels.length; i++) {
    var jsonItem = channels[i];
    if (id == jsonItem.ID) {
      result = jsonItem.Title;
      break;
    }
  }
  return result;
};

let channels = [
  {
    ID: "5cb3f063e1382306c3acac55",
    Title: "关于我们"
  },
  {
    ID: "5cb3f0b9e1382306c3acac5e",
    Title: "研究院简介"
  },
  {
    ID: "5cb3f0c3e1382306c3acac5f",
    Title: "Introduction"
  },
  {
    ID: "5cb3f0cbe1382306c3acac60",
    Title: "研究院理事会"
  },
  {
    ID: "5cb3f0d1e1382306c3acac61",
    Title: "研究院领导"
  },
  {
    ID: "5cb3f0d8e1382306c3acac62",
    Title: "联系我们"
  },
  {
    ID: "5cb3f072e1382306c3acac56",
    Title: "研究领域"
  },
  {
    ID: "5cb3f079e1382306c3acac57",
    Title: "新闻动态"
  },
  {
    ID: "5cb3f083e1382306c3acac58",
    Title: "媒体报道"
  },
  {
    ID: "5cb3f08be1382306c3acac59",
    Title: "专家团队"
  },
  {
    ID: "5e853a9de1382309cc85cbbb",
    Title: "专家指导委员会"
  },
  {
    ID: "5e853aabe1382309cc85cbbc",
    Title: "学术委员会"
  },
  {
    ID: "5cb3f091e1382306c3acac5a",
    Title: "直属机构"
  },
  {
    ID: "5cb3f09be1382306c3acac5b",
    Title: "合作机构"
  },
  {
    ID: "5cb3f0a2e1382306c3acac5c",
    Title: "学术观点"
  },
  {
    ID: "5cb3f0a9e1382306c3acac5d",
    Title: "通知公告"
  }
];

export default model;
